import { render, staticRenderFns } from "./ReportsType.vue?vue&type=template&id=4f53543f"
import script from "./ReportsType.vue?vue&type=script&lang=js"
export * from "./ReportsType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports